export function IndexTags(alltags) {
    return alltags.reduce((acc, item) => {
        acc[item.Name] = item.Color;
        return acc;
    }, {})
}

export function tagFilter(alltags, selectedTags, data, combine) { // categorizing tag data to be scored
        
        const tagIndex = IndexTags(alltags)

        var tagScores = []
        var tagDict = {}

        for (let i = 0; i < data.length; i++) {

            const current = data[i]
            const combined = [...selectedTags, ...current.Tags]

            let tracking = {} // category (ex: c): set(vals (ex: herniated disc))

            let absoluteMatches = 0 // absolute amount of elems that match
            let absoluteElems = 0 // absolute amount of unique elems

            let fullCatCount = new Set() // categories which have a common element in both lists
            let catCount = 0 // all categories that elements in the lists are
            
            for (let j = 0; j < combined.length; j++) {
                const elem = combined[j]
                const cat = tagIndex[elem]
                if (tracking[cat]) { // if the category has already been instantiated (one of the tags already seen is in that category)

                    if (tracking[cat].has(elem)) { // if there is already a presence if the tag
                        fullCatCount.add(cat) // duplicates not allowed in sets
                        absoluteMatches++ // found a new unique match
                    }
                    else { // tag hasn't been seen before
                        absoluteElems++ // unique new tag has been found
                        tracking[cat].add(elem)
                    }
                }
                else {
                    catCount++ // new category is found
                    absoluteElems++ // increment since we find a new element within the new category
                    tracking[cat] = new Set([elem])
                }
            }

            fullCatCount = fullCatCount.size

            // changing dict to its int length to use in calculations. 
            // Dict stored which categories already found (no longer needed)

            const Lweight = .7 // Weight given to having 1 match per category
            const Sweight = 1 - Lweight
            const score = Lweight - Lweight * fullCatCount/catCount + (Sweight - Sweight * absoluteMatches/absoluteElems)

            tagScores.push({item: current, score: score}) // scoring tag
            tagDict[current.id] = {item: current, score: score}
        }

        return combine ? tagDict : tagScores
    }

export function haversineDistance(lat1, lon1, lat2, lon2) {
  const R = 3958.8; // Radius of Earth in miles
  const toRad = (deg) => (deg * Math.PI) / 180;

  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);

  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
    Math.sin(dLon / 2) ** 2;

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return R * c;
}

export const states = {
    AL: "Alabama", AK: "Alaska", AZ: "Arizona", AR: "Arkansas", CA: "California",
    CO: "Colorado", CT: "Connecticut", DE: "Delaware", FL: "Florida", GA: "Georgia",
    HI: "Hawaii", ID: "Idaho", IL: "Illinois", IN: "Indiana", IA: "Iowa",
    KS: "Kansas", KY: "Kentucky", LA: "Louisiana", ME: "Maine", MD: "Maryland",
    MA: "Massachusetts", MI: "Michigan", MN: "Minnesota", MS: "Mississippi", MO: "Missouri",
    MT: "Montana", NE: "Nebraska", NV: "Nevada", NH: "New Hampshire", NJ: "New Jersey",
    NM: "New Mexico", NY: "New York", NC: "North Carolina", ND: "North Dakota", OH: "Ohio",
    OK: "Oklahoma", OR: "Oregon", PA: "Pennsylvania", RI: "Rhode Island", SC: "South Carolina",
    SD: "South Dakota", TN: "Tennessee", TX: "Texas", UT: "Utah", VT: "Vermont",
    VA: "Virginia", WA: "Washington", WV: "West Virginia", WI: "Wisconsin", WY: "Wyoming"
  };

  export const STATE_SCALE = {
  // Approx. half of previous values — larger states still larger, smaller states smaller.
  AK: 1.25, TX: 1.00, CA: 0.95, MT: 0.88, NM: 0.80, AZ: 0.80, NV: 0.75, ID: 0.73,
  OR: 0.70, CO: 0.70, WY: 0.68, MI: 0.65, MN: 0.65, UT: 0.65, WA: 0.63, FL: 0.60,
  NY: 0.58, WI: 0.55, IL: 0.53, PA: 0.53, OH: 0.53, GA: 0.53, NC: 0.53, VA: 0.50,
  TN: 0.49, MO: 0.49, IN: 0.48, KY: 0.48, LA: 0.48, AR: 0.48, AL: 0.48, MS: 0.45,
  OK: 0.45, KS: 0.45, IA: 0.45, NE: 0.45, SC: 0.45, ME: 0.43, WV: 0.43, NH: 0.40,
  VT: 0.40, MD: 0.38, NJ: 0.38, MA: 0.35, CT: 0.35, DE: 0.33, RI: 0.30, DC: 0.25
  };